module.exports = __webpack_public_path__ + "static/media/doctor.2caeb251.svg";